import { useEffect } from 'react';
import { canonicalSignupUrl, SIGNUP_URL } from '@gf/shared/site-urls';
import { readStoredSession } from '../pages/auth/signup/flow';

/** Compatibility for a portal tab that still navigates to the old route. */
export function SignupRedirect() {
  useEffect(() => {
    location.replace(canonicalSignupUrl(location.search, location.hash, readStoredSession()));
  }, []);
  return <p>Continue your signup on <a href={SIGNUP_URL}>www.gramfather.com</a>.</p>;
}
